import {
  Component,
  Inject,
  OnInit,
  ViewChild,
  AfterViewInit,
  OnDestroy,
  HostListener,
  AfterContentChecked,
  AfterViewChecked, ViewEncapsulation, Input
} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { addZeitStart } from '../../store/actions/Zeit-add.actions';
import { select, Store } from '@ngrx/store';
import { Zeitstate } from '../../store/reducer/zeiterfassung.reducer';
import { MatCheckbox } from '@angular/material/checkbox';
import { editZeitStart } from '../../store/actions/Zeit-edit.actions';
import {ZeiterfassungStufenComponent} from '../zeiterfassung-stufen/zeiterfassung-stufen.component';
import {NodeItem} from '../../../projektverwaltung/node.model';
import {Observable} from 'rxjs';
import {SpesenItem} from '../../spesen.model';
import {SpesenFormdialogComponent} from '../spesen-form-dialog/spesen-formdialog.component';
import {loadSpesenartenStart} from '../../store/actions/spesenart.actions';
import {deleteZeitStart} from '../../store/actions/Zeit-del.actions';
import {deleteAllSpesenOfZeitStart} from '../../store/actions/allSpesenOfZeit-del.actions';
import {CacheItem} from '../../cache.model';
import {loadCacheStart} from '../../store/actions/getCacheNodes.actions';
import {DashboardItem} from '../../../landingpage/dashboard.model';
import {loadProjektSelectboxStart} from '../../store/actions/project-selectbox.actions';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {Security} from '../../../../security';
import {asNumber} from 'wijmo/wijmo';
import {loadIstZeitStart} from '../../store/actions/getIstZeit';
import {element} from 'protractor';
import {map, startWith} from 'rxjs/operators';
import {BreakpointObserver} from '@angular/cdk/layout';
import {MatAutocomplete} from '@angular/material/autocomplete';
import {loadTaetCacheStart} from '@src/app/pages/Zeiterfassung/store/actions/getTaetCache.actions';


/* Projekt Auswahl */
export interface ProjektDaten {
  prjID: number;
  prjName?: string;
  prjPRJ?: number;
  prjLevel?: number;
}

/* Ende Projekt Auswahl */

export interface DialogData {
  id: number;
  title: string;
  spesenTitle: string;
  submitButtonLabel: string;
  datum: Date;
  serienDatum: Date[];
  dauerIntern: string;
  dauerExtern: string;
  text: string;
  verrechnen: any;
  verrechnet: any;
  niverbar: any;
  projekt: string;
  projektstufe0: string;
  letzteProjektstufe: string;
  cancelButtonLabel: string;
  spesenTotal: number;
  deletable: boolean;
  sollZeit: number;
  istZeit: number;
  restZeit: number;
  ferien: string;
}

@Component({
  selector: 'app-zeiterfassung-formdialog-neu',
  templateUrl: './zeiterfassung-formdialog-neu.component.html',
  styleUrls: ['./zeiterfassung-formdialog-neu.component.scss'],
})

export class ZeiterfassungFormdialogNeuComponent implements OnInit, AfterViewChecked, OnDestroy {

  constructor(public dialogRef: MatDialogRef<ZeiterfassungFormdialogNeuComponent>,
              @Inject(MAT_DIALOG_DATA) public data: DialogData,
              public fB: FormBuilder,
              public dialog: MatDialog,
              public store: Store<{ zeiterfassung: Zeitstate }>,
              private breakpointObserver: BreakpointObserver
  ) {

    dialogRef.disableClose = true;

    this.$projektSelectbox = store.pipe(select((state) => state.zeiterfassung.selectboxProjekte));
    this.$spesen = store.pipe(select((state) => state.zeiterfassung.spesen));
    this.$cache = store.pipe(select((state) => state.zeiterfassung.cacheNodes));
    this.$istZeit = store.pipe(select((state) => state.zeiterfassung.istZeit));
    this.$sollZeit = store.pipe(select((state) => state.zeiterfassung.sollZeit));
    this.$taetCache = store.pipe(select((state) => state.zeiterfassung.taetNodes));
    /* Projekt Auswahl */
    /* Ende Projekt Auswahl */
    console.log(moment(data.datum).format('YYYY-MM-DD'));
    if (this.data.id === undefined) {
      this.data.verrechnen = '1';
      this.data.verrechnet = 0;
    } else {
      if (this.data.verrechnen == 'Ja'){
        this.data.verrechnen = '1';
      }
      else{
        this.data.verrechnen = '2';
      }
      this.data.verrechnet = this.neuOderBearbeiten(this.data.verrechnet);
    }
    this.ferien = parseInt(this.data.ferien, 10) - 1;
    /* Gridwerte in die Bearbeiten Maske hineinschreiben */
    this.timeForm.patchValue({
      /* Wandelt beim Bearbeiten das Datum und liest es in Maske ein */
      datum: moment(data.datum).format('YYYY-MM-DD'),
      /* Ende Umwandler */
      dauerIntern: parseFloat(data.dauerIntern).toFixed(2),
      dauerExtern: parseFloat(data.dauerExtern).toFixed(2),
      text: data.text,
      verrechnen: this.data.verrechnen,
      verrechnet: this.data.verrechnet,
      niverbar: this.data.niverbar,
      projekt: data.projekt,
      projektstufe0: data.projektstufe0,
      letzteProjektstufe: data.letzteProjektstufe,
      tagesist: data.istZeit,
      tagessoll: data.sollZeit,
      tagesrest: data.restZeit,
      ferien: !!this.ferien,
    });
    this.setProjektstufeDisabled(!!this.ferien);
    // tslint:disable-next-line:max-line-length
    // EDIT ZEIT
    if (data.id){
      this.store.dispatch(loadIstZeitStart({datum: this.timeForm.controls.datum.value}));
      this.updateTagesIstWithoutTime(true);
    }
    // ADD ZEIT
    else{
      this.calculateDayIsTime(this.timeForm.controls.datum.value);
    }
    this.calculateTime();

  }

  /* Ende Projekt Auswahl */
  private myTimer;


  @ViewChild(ZeiterfassungStufenComponent) stufe;

  public ferien: number;
  public disableProjektstufe: boolean;
  public $spesen: Observable<SpesenItem[]>;
  public $cache: Observable<DashboardItem[]>;
  public $taetCache: Observable<string[]>;
  public $taetCacheFiltered: Observable<string[]>;
  public $projektSelectbox: Observable<NodeItem[]>;
  public $istZeit: Observable<number>;
  public $sollZeit: Observable<number>;
  /* Speichert die Werte des Formulars */
  public timeForm = new FormGroup({
    datum: new FormControl(''),
    dauerIntern: new FormControl('', [Validators.required]),
    dauerExtern: new FormControl('', [Validators.required]),
    text: new FormControl('', [Validators.pattern('[^\']+')]),
    verrechnen: new FormControl('' ),
    verrechnet: new FormControl({value: '', disabled: this.data.niverbar === 'Ja'}),
    niverbar: new FormControl(''),
    /* Inputfeld */
    projekt: new FormControl(''),
    cache: new FormControl(''),
    tagestotal: new FormControl(''),
    tagesist: new FormControl({value: '', disabled: true}),
    tagessoll: new FormControl(''),
    tagesrest: new FormControl(''),
    start: new FormControl(),
    end: new FormControl(),
    serienDatum: new FormControl({value: 'f', disabled: true }),
    ferien: new FormControl(''),
    });

  /* Zuweisen der Werte vom Kind in die Variable daten */
  daten;
  /* holt die letzteProjektstufe */
  private rest: number;
  public tagesIstWithoutThisTime: number;
  public isSmallDevice = false;
  /* Abbruchfunktion */
  // tslint:disable-next-line:typedef
  private restIntern: number;
  private restExtern: number;
  @Input() auto: MatAutocomplete;
  options: string[] = ['One', 'Two', 'Three'];
  filteredOptions: Observable<string[]>;
  myControl = new FormControl('');
  daysSelected: any[] = [];
  event: any;
  public showInInput: string;

  @HostListener('window:beforeunload', [ '$event' ])
  // tslint:disable-next-line:typedef
  beforeUnloadHandler(event) {
    if ( isNaN( Number(sessionStorage.getItem('zeitId'))) === false){
      this.store.dispatch(deleteAllSpesenOfZeitStart({zeitId: parseInt(sessionStorage.getItem('zeitId'), 10)}));
      this.store.dispatch(deleteZeitStart({
      // tslint:disable-next-line:radix
      item: {id: parseInt(sessionStorage.getItem('zeitId')),
        title: null,
        spesenTitle: null,
        submitButtonLabel: null,
        datum: null,
        dauerIntern: null,
        dauerExtern: null,
        text: null,
        verrechnen: null,
        verrechnet: null,
        niverbar: null,
        projekt: null,
        projektstufe0: null,
        letzteProjektstufe: null,
        cancelButtonLabel: null,
        spesenTotal: null,
        deletable: null,
        sollZeit: null,
        istZeit: null,
        restZeit: null,
        serienDatum: null,
        ferien: null,
      },
    }));
    }
    sessionStorage.setItem('zeitId', null);
  }


  public getErrorMessage(Feld: string): string {
    const formControl = this.timeForm.get(Feld);
    if (formControl.hasError('required')){
      return`pages.timeDialog.formValidation.error.${Feld}.required`;
    }
    else if ( formControl.hasError('pattern')){
      return `pages.timeDialog.formValidation.error.${Feld}.pattern`;
    }
    return 'pages.timeDialog.formValidation.error.generic';
  }

  /* Ende Checkbox 3 */

  /* Wandelt Datum um: Ohne Zeitzone und im richtigen Backendformat */
  public wandler(datum: any): any {
    // tslint:disable-next-line:triple-equals
    if (datum == undefined){
      return null;
    }
    const dwD = datum.toLocaleString( 'en-US', {timezone: 'utc'} );
    const backendDat = moment(dwD).format('YYYY-MM-DD');
    return backendDat;
  }

  /* Entscheidet ob Daten der Checkbox verrechnen in der Neu Maske oder Bearbeiten Maske ausgegeben werden soll */
  public neuOderBearbeiten(checkboxCheck: any): any {
    // tslint:disable-next-line:triple-equals
     if (checkboxCheck == 'Ja') {
      return 1;
    } else {
      return 0;
    }
  }

  public dauerUebergeben(dauer: number): void{
    this.timeForm.patchValue({
      dauerExtern: dauer,
    });
  }

  // tslint:disable-next-line:typedef use-lifecycle-interface
  public ngAfterViewChecked(){
    this.daten = this.stufe.addButtonForm;
  }
  // tslint:disable-next-line:typedef
  ngOnDestroy() {
    // Falls keine Zahl in der Session ist löscht es auch nichts
    if ( isNaN( Number(sessionStorage.getItem('zeitId'))) === false){
      this.store.dispatch(deleteAllSpesenOfZeitStart({zeitId: parseInt(sessionStorage.getItem('zeitId'), 10)}));
      this.store.dispatch(deleteZeitStart({
      item: {id: parseInt(sessionStorage.getItem('zeitId'), 10),
        title: null,
        spesenTitle: null,
        submitButtonLabel: null,
        datum: null,
        dauerIntern: null,
        dauerExtern: null,
        text: null,
        verrechnen: null,
        verrechnet: null,
        niverbar: null,
        projekt: null,
        projektstufe0: null,
        letzteProjektstufe: null,
        cancelButtonLabel: null,
        spesenTotal: null,
        deletable: null,
        sollZeit: null,
        istZeit: null,
        restZeit: null,
        serienDatum: null,
        ferien: null,
      },
    }));
  }
    sessionStorage.setItem('zeitId', null);
  }
  /* Ende Zuweisen der Werte vom Kind in die Variable daten */

  public ngOnInit(): void {
  /*  this.filteredOptions = this.timeForm.controls.cache.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '')),
    );*/
    sessionStorage.setItem('taetEingabe', '');
    sessionStorage.setItem('spesenartIsAktiv', '1');
    this.store.dispatch(loadTaetCacheStart({prjId: 0, eingabe: ''}));
    this.store.dispatch(loadSpesenartenStart());
    this.store.dispatch(loadCacheStart());

  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.options.filter(option => option.toLowerCase().includes(filterValue));
  }

  public handleSubmitClick(): void {
    const item = this.timeForm.value;
    if ( !this.data?.id){
      item.id = sessionStorage.getItem('zeitId');
      console.log('first');
    }else{
      item.id = this.data.id;
      console.log('second');
    }
    if (item.verrechnen == 1){
      item.verrechnen = 1;
      item.niverbar = 0;
    }
    else{
      item.verrechnen = 0;
      item.niverbar = 1;
      item.verrechnet = 0;
    }
    if(!item.ferien){
      item.projektstufe0 = this.daten.value.projektstufe0;
      // get highest projektstufe
      item.letzteProjektstufe = this.getLastProjektstufe();
      item.ferien = 1;
    }
    else{
      item.projektstufe0 = null;
      item.ferien = 2;
    }

    item.serienDatum = this.daysSelected;

    if (item.serienDatum.length === 0){
      this.timeForm.value.datum = this.wandler(this.timeForm.value.datum);
    }
    else{
      this.timeForm.value.datum = '';
    }
    this.store.dispatch(editZeitStart({ item }));

    sessionStorage.setItem('zeitId', null);
    this.dialogRef.close('stopTheButton');

  }


  public handleCancelClick(): void {
    this.dialogRef.close(true);
  }
  public getLastProjektstufe(): NodeItem{
    // tslint:disable-next-line:prefer-const
    let projektStufe;
    let letzteStufe;
    for (let i = 0; i < 1000; i++){
      const testString = 'projektStufe = this.daten.value.projektstufe' + i;
      // tslint:disable-next-line:no-eval
      eval(testString);
      if (projektStufe?.children?.length === 0){
        letzteStufe = projektStufe;
        return letzteStufe;
      }
      else if (projektStufe !== undefined && projektStufe !== ''){
        letzteStufe = projektStufe;

      }
      else{
        return letzteStufe;
      }
    }
  }

  public addSpesen(): void{
    if (this.data.id === undefined){
    this.data.id = Number(sessionStorage.getItem('zeitId'));
  }

    if(this.isSmallDevice){
      this.dialog.open(SpesenFormdialogComponent, {
        maxWidth: '90%',
        data: {
          title: 'pages.zeitverwaltung.addSpesenDialog.title',
          submitButtonLabel: 'pages.addTimeDialog.submitButtonLabel',
          cancelButtonLabel: 'pages.addTimeDialog.cancelButtonLabel',
          menge: null,
          zeitId: this.data.id,
        },
      });
    }
    else{
      this.dialog.open(SpesenFormdialogComponent, {
        data: {
          title: 'pages.zeitverwaltung.addSpesenDialog.title',
          submitButtonLabel: 'pages.addTimeDialog.submitButtonLabel',
          cancelButtonLabel: 'pages.addTimeDialog.cancelButtonLabel',
          menge: null,
          zeitId: this.data.id,
        },
      });
    }
  }

  public selectProjects(projektId: number): void {
    this.store.dispatch(loadProjektSelectboxStart({projektId}));
  }

  public updateTagesIstWithoutTime(mitDauerInt: boolean): void{
    if (!this.timeForm.controls.dauerIntern.value){
      this.timeForm.patchValue({
        dauerIntern:  0,
      });
    }
    if (mitDauerInt){
      // tslint:disable-next-line:max-line-length
      this.tagesIstWithoutThisTime = Math.round((this.timeForm.controls.tagesist.value - parseFloat( this.timeForm.controls.dauerIntern.value)) * 100) / 100;
    }
    else{

        this.tagesIstWithoutThisTime = Math.round((this.timeForm.controls.tagesist.value) * 100) / 100;

        this.timeForm.patchValue({
          // tslint:disable-next-line:max-line-length
          tagesist:  (Math.round((this.tagesIstWithoutThisTime + parseFloat( this.timeForm.controls.dauerIntern.value)) * 100) / 100).toFixed(2),
        });

    }
    // tslint:disable-next-line:max-line-length
}

  public calculateRest(): void{
    this.rest = (Math.round( (this.timeForm.controls.tagessoll.value -  this.timeForm.controls.tagesist.value) * 100) / 100);
    this.timeForm.patchValue({
      tagesrest: this.rest.toFixed(2),
    });
  }

  public calculateTime(): void{
    if (!parseFloat( this.timeForm.controls.dauerIntern.value)){
      this.rest = this.tagesIstWithoutThisTime;
    }
    else{
      this.rest = this.tagesIstWithoutThisTime + parseFloat(this.timeForm.controls.dauerIntern.value);
    }

    if (this.rest !== undefined){
    this.timeForm.patchValue({
      tagesist:  this.rest.toFixed(2),
    });
    }
  }

  public calculateDayIsTime(datum: string): void{

    datum = this.wandler(datum);
    this.store.dispatch(loadIstZeitStart({datum}));

    // update tagesIstWithoutThisTime
      // tslint:disable-next-line:only-arrow-functions
    this.myTimer = setTimeout ( function(): void{
          document.getElementById('updateButton').click();
      }  , 500);
  }

  public zeitVerteilen(zeitRest: number): void{

    this.restIntern = parseFloat( this.timeForm.controls.dauerIntern.value ) + parseFloat(String(zeitRest));
    this.restExtern = parseFloat(this.timeForm.controls.dauerExtern.value) + parseFloat(String(zeitRest));

    this.timeForm.patchValue({
      dauerIntern:  this.restIntern.toFixed(2),
      dauerExtern:  this.restExtern.toFixed(2),
    });
  }


  public disableVerrechnet(disableVerrechnet: boolean): void{
    if   (disableVerrechnet){
      this.timeForm.patchValue({
        verrechnet:  0,
      });
      this.timeForm.get('verrechnet').disable();
    }
    else{
      this.timeForm.get('verrechnet').enable();
    }
  }
  isSelected = (event: any) => {
    const date =
      event.getFullYear() +
      '-' +
      ('00' + (event.getMonth() + 1)).slice(-2) +
      '-' +
      ('00' + event.getDate()).slice(-2);
    return this.daysSelected.find(x => x == date) ? 'selected' : null;
  }

  select(event: any, calendar: any): void {
    const date =
      event.getFullYear() +
      '-' +
      ('00' + (event.getMonth() + 1)).slice(-2) +
      '-' +
      ('00' + event.getDate()).slice(-2);
    const index = this.daysSelected.findIndex(x => x == date);
    // date = moment(date).format('DD.MM.YYYY');

    if (index < 0) { this.daysSelected.push(date); }
    else { this.daysSelected.splice(index, 1); }

    calendar.updateTodaysDate();

    this.showInInput = this.daysSelected.toString();

  }

  public filter(filterEingabe: string): void{
    sessionStorage.setItem('taetEingabe', filterEingabe);
    this.store.dispatch(loadTaetCacheStart({prjId: parseInt(sessionStorage.getItem('taetPrjId'), 10), eingabe: filterEingabe}));
  }



  public nichtVerrechnenVerrechnen(verNiver: boolean): void{
    console.log(verNiver);
    this.timeForm.patchValue({
      verrechnen: (verNiver ? 1 : 2).toString(),
    });
    if(!verNiver){
      this.disableVerrechnet(true);
    }

  }

  public setProjektstufeDisabled(checked: boolean): void{


    this.disableProjektstufe = checked;
    if(checked){
      this.timeForm.patchValue({
        verrechnen: '2',
      });
      this.timeForm.get('cache').disable();
    }
    else{
      this.timeForm.get('cache').enable();
    }
  }

}

